// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"321":"5309e43a","688":"1ffdf7f1"}[chunkId] + ".chunk.css";
};